import React from "react";
import PropTypes from "prop-types";

import { TextOverflow } from "utils/common";
import StatusColumn from "widgets/grid/cells/StatusColumn";

export default function VersionImportTable(props){
	const { creatives } = props;
	const rows = creatives.map((creative) => {
		const { name, id, approval, new: newCreatives = 0, updated = 0 } = creative || {};
		return (
			<tr key={id}>
				<td className="name-col"><TextOverflow value={name} /></td>
				<td className="creative-id-column id-col">{id}</td>
				<td className="creative-status-column status-col"><StatusColumn value={approval} shouldShowLinks={false} /></td>
				<td className="creative-versions-column">{`${newCreatives} New, ${updated} Updated`}</td>
			</tr>
		);
	});

	return (
		<table className="creatives-import-table basic-table">
			<thead>
				<tr>
					<th className="name-col">Creative Name</th>
					<th className="creative-id-column id-col">ID</th>
					<th className="status-col">Status</th>
					<th className="creative-versions-column">Versions</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

VersionImportTable.displayName = "VersionImportTable";
VersionImportTable.propTypes = {
	creatives: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string.isRequired,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		approval: PropTypes.string.isRequired,
		new: PropTypes.number,
		updated: PropTypes.number,
	})),
};
